import { render, staticRenderFns } from "./ConfigsRoot.vue?vue&type=template&id=6e681fae&"
import script from "./ConfigsRoot.vue?vue&type=script&lang=js&"
export * from "./ConfigsRoot.vue?vue&type=script&lang=js&"
import style0 from "./ConfigsRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports